module.exports = __webpack_public_path__ + "img/091.24bcaf3a.png";